import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = { class: "relative inline-block w-12 mr-2 align-middle select-none transition transform duration-300 ease-in-out" }
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        value: _ctx.updatedValue,
        type: "checkbox",
        id: "toggle",
        class: _normalizeClass(["toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer", { 'right-0 border-green': _ctx.updatedValue }]),
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSwitch && _ctx.toggleSwitch(...args)))
      }, null, 42, _hoisted_3),
      _createElementVNode("div", {
        class: _normalizeClass(["toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer", { 'bg-green': _ctx.updatedValue }])
      }, null, 2)
    ]),
    _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
  ]))
}